export var dangerous = ['cent', 'copy', 'divide', 'gt', 'lt', 'not', 'para', 'times'];